import { render } from "./Index.vue?vue&type=template&id=094fb4d9&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=094fb4d9&lang=scss&scoped=true"

import exportComponent from "D:\\java\\code\\overseas_code\\wlxf-official-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-094fb4d9"]])

export default __exports__